export default class User {
  constructor(
    public id: string,
    public role: string,
    public isViewOnly: boolean,
    public isAdminUser: boolean
  ) {}
}
